import { getLogger } from '@cld/upload-widget';
import t from 'common/i18n';
import validateImageForUpload from './validateImageForUpload';

const logger = getLogger();

const getMaxInvalidMessage = (width, height, maxWidth, maxHeight) =>
  t('uploader.errors.max_dimensions_validation', {
    width,
    height,
    maxWidth: maxWidth || t('uploader.errors.unavailable'),
    maxHeight: maxHeight || t('uploader.errors.unavailable'),
  });

export default (context, data, options) =>
  validateImageForUpload(
    data,
    context,

    (img, dfd) => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      const maxWidth = data.imageMaxWidth;
      const maxHeight = data.imageMaxHeight;

      const invalid = (maxWidth && width > maxWidth) || (maxHeight && height > maxHeight);

      if (invalid) {
        logger.log(`[jqFU.processor.validateMaxWidthHeight]: validation check on width/height failed -
			image:(${width}/${height}) max:(${maxWidth}/${maxHeight})`);

        data.files.error = true;
        data.files[0] = { error: getMaxInvalidMessage(width, height, maxWidth, maxHeight) };
        dfd.rejectWith(context, [data]);
      } else {
        dfd.resolveWith(context, [data]);
      }
    },
    options
  );
